import * as React from "react";
import { View, Text, TouchableOpacity, StyleSheet } from "react-native";
import { currentLanguage } from "../../translations/CurrentLanguage";

import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import translation from "../.././translations/translation";
import LocalizedStrings from "react-native-localization";
import { colors, radius } from "../../theme/modern";

let strings = new LocalizedStrings(translation);

const PrinterComponent = props => {
  strings.setLanguage(currentLanguage().companyLanguage);
  const online = !!props.connection;

  return (
    <View style={props.style}>
      <Text style={styles.label}>{strings.PrinterStatus}</Text>
      <View style={styles.row}>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={props.onPrinterPress}
          style={styles.status}
        >
          <Icon name="printer" size={22} color="#334155" />
          <View style={[styles.dot, online ? styles.dotOnline : null]} />
          <Text style={[styles.statusText, online ? styles.online : null]}>
            {online ? "Online" : props.connectionStatus}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          activeOpacity={0.7}
          onPress={props.connectDevice}
          style={styles.connect}
        >
          <Icon name="refresh" size={20} color={colors.primary} />
        </TouchableOpacity>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  label: {
    marginBottom: 8,
    fontSize: 13,
    fontWeight: "600",
    color: colors.textMuted,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
  },
  status: {
    flex: 1,
    height: 46,
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: 14,
    borderRadius: radius.medium,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surface,
  },
  dot: {
    width: 8,
    height: 8,
    marginLeft: 12,
    marginRight: 6,
    borderRadius: 4,
    backgroundColor: colors.textFaint,
  },
  dotOnline: {
    backgroundColor: colors.success,
  },
  statusText: {
    fontSize: 14,
    fontWeight: "600",
    color: colors.textMuted,
  },
  online: {
    color: colors.success,
  },
  connect: {
    width: 46,
    height: 46,
    marginLeft: 8,
    borderRadius: radius.medium,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: colors.primarySoft,
  },
});

export default PrinterComponent;
